import "../App.css";
import logo from "../logo.png";
import logoKidDiary from "../s_kiddiaryicon.png";
// import ReactGA from 'react-ga';
// import TagManager from 'react-gtm-module'
import GA4React from "ga-4-react";
import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";

let ga4react = null;

export async function init(G) {
  if (!GA4React.isInitialized()) {
    try {
      ga4react = new GA4React("G-NPEST2Q6EN");
      await ga4react.initialize();
      ga4react.event("open_website");
      ga4react.pageview("/");
    } catch (error) {
      console.error(error);
    }
  }
}

function NutStatCalBMI() {
  const refScroll = useRef(null);

  init();

  const [gender, setGender] = useState("M");

  const [birthDate, setBirthDate] = useState(parseInt(getCurrentDay()));
  const [birthMonth, setBirthMonth] = useState(parseInt(getCurrentMonth()));
  const [birthYear, setBirthYear] = useState(parseInt(getCurrentYear()));

  const [birthDateValue, setBirthDateValue] = useState(
    parseInt(getCurrentDay())
  );
  const [birthMonthValue, setBirthMonthValue] = useState(
    parseInt(getCurrentMonth())
  );
  const [birthYearValue, setBirthYearValue] = useState(
    parseInt(getCurrentYear())
  );

  const [measureDate, setMeasureDate] = useState(parseInt(getCurrentDay()));
  const [measureMonth, setMeasureMonth] = useState(parseInt(getCurrentMonth()));
  const [measureYear, setMeasureYear] = useState(parseInt(getCurrentYear()));

  const [measureDateValue, setMeasureDateValue] = useState(
    parseInt(getCurrentDay())
  );
  const [measureMonthValue, setMeasureMonthValue] = useState(
    parseInt(getCurrentMonth())
  );
  const [measureYearValue, setMeasureYearValue] = useState(
    parseInt(getCurrentYear())
  );

  const [inputType, setInputType] = useState(1);

  const [kindMonth, setKindMonth] = useState(0);
  const [kindMonthText, setKindMonthText] = useState(0);

  const [kindWeight, setKindWeight] = useState("");
  const [kindHeight, setKindHeight] = useState("");

  const [kindDirectMonth, setKindDirectMonth] = useState(0);
  const [kindDirectYear, setKindDirectYear] = useState(0);

  const [errorMessage, setErrorMessage] = useState("");

  const [graphImage, setGraphImage] = useState("");

  const [bmiBucketIndex, setBmiBucketIndex] = useState(null); // 0..5 ตามช่วง
  const [bmiRangeText, setBmiRangeText] = useState("-"); // เช่น '-2SD to -1SD'
  const [isLoading, setIsLoading] = useState(false);

  const [result, setResult] = useState({
    kind_month: "-",
    kind_gender: "-",
    kind_birthday: "-",
    kind_height: "-",
    kind_weight: "-",
    measure_date: "-",
    ideal: "-",
    mean: "-",
    weight_level: 0,
    weight_color: "",
    height_level: 0,
    height_color: "",
    ha: "-",
    ha_persentage: "-",
  });

  console.log("kindDirectYear: " + kindDirectYear);
  console.log("kindDirectMonth: " + kindDirectMonth);

  let itemsDate = [
    { id: 1, description: "1" },
    { id: 2, description: "2" },
    { id: 3, description: "3" },
    { id: 4, description: "4" },
    { id: 5, description: "5" },
    { id: 6, description: "6" },
    { id: 7, description: "7" },
    { id: 8, description: "8" },
    { id: 9, description: "9" },
    { id: 10, description: "10" },
    { id: 11, description: "11" },
    { id: 12, description: "12" },
    { id: 13, description: "13" },
    { id: 14, description: "14" },
    { id: 15, description: "15" },
    { id: 16, description: "16" },
    { id: 17, description: "17" },
    { id: 18, description: "18" },
    { id: 19, description: "19" },
    { id: 20, description: "20" },
    { id: 21, description: "21" },
    { id: 22, description: "22" },
    { id: 23, description: "23" },
    { id: 24, description: "24" },
    { id: 25, description: "25" },
    { id: 26, description: "26" },
    { id: 27, description: "27" },
    { id: 28, description: "28" },
    { id: 29, description: "29" },
    { id: 30, description: "30" },
    { id: 31, description: "31" },
  ];

  let itemsMonth = [
    { id: 1, description: "มกราคม" },
    { id: 2, description: "กุมภาพันธ์" },
    { id: 3, description: "มีนาคม" },
    { id: 4, description: "เมษายน" },
    { id: 5, description: "พฤษภาคม" },
    { id: 6, description: "มิถุนายน" },
    { id: 7, description: "กรกฎาคม" },
    { id: 8, description: "สิงหาคม" },
    { id: 9, description: "กันยายน" },
    { id: 10, description: "ตุลาคม" },
    { id: 11, description: "พฤศจิกายน" },
    { id: 12, description: "ธันวาคม" },
  ];

  let itemsYear = [];
  initYear(100);

  function splitAgeYM(totalMonths) {
    const y = Math.floor(Number(totalMonths || 0) / 12);
    const m = Number(totalMonths || 0) % 12;
    return { y, m };
  }

  function getBmiLevel(levelIndex) {
    // ถ้า index ตรงช่องนี้ → ไฮไลต์
    if (bmiBucketIndex === levelIndex) return "#22c55e"; // สีเขียวพาสเทล
    return ""; // ช่องอื่นไม่ระบายสี (จะเห็นเป็นเทาอ่อนจาก class เดิม)
  }

  const spinnerBirthDate = (event) => {
    setBirthDateValue(parseInt(event.target.value));
    setBirthDate(parseInt(event.target.value));
    setKindMonth(getKidMonth());
  };

  const spinnerBirthMonth = (event) => {
    setBirthMonthValue(parseInt(event.target.value));
    setBirthMonth(parseInt(event.target.value));
    setKindMonth(getKidMonth());
  };
  const spinnerBirthYear = (event) => {
    setBirthYearValue(parseInt(event.target.value));
    setBirthYear(parseInt(event.target.value));
    setKindMonth(getKidMonth());
  };

  const spinnerMeasureDate = (event) => {
    setMeasureDateValue(parseInt(event.target.value));
    setMeasureDate(parseInt(event.target.value));
    setKindMonth(getKidMonth());
  };

  const spinnerMeasureMonth = (event) => {
    setMeasureMonthValue(parseInt(event.target.value));
    setMeasureMonth(parseInt(event.target.value));
    setKindMonth(getKidMonth());
  };
  const spinnerMeasureYear = (event) => {
    setMeasureYearValue(parseInt(event.target.value));
    setMeasureYear(parseInt(event.target.value));
    setKindMonth(getKidMonth());
  };

  function initYear(total) {
    let nowDate = getCurrentDate("-");
    let nowDateArray = nowDate.split("-");

    for (let i = 0; i <= total; i++) {
      let yearEng = parseInt(nowDateArray[0]) - i;
      let yearTh = yearEng + 543;
      itemsYear.push({ id: yearEng, description: yearTh });
    }
  }

  function getCurrentDate(separator = "") {
    let date = getCurrentDay();
    let month = getCurrentMonth();
    let year = getCurrentYear();

    return `${year}${separator}${
      month < 10 ? `0${month}` : `${month}`
    }${separator}${date}`;
  }

  function getCurrentYear() {
    let newDate = new Date();
    return newDate.getFullYear();
  }
  function getCurrentMonth() {
    let newDate = new Date();
    return newDate.getMonth() + 1;
  }
  function getCurrentDay() {
    let newDate = new Date();
    return newDate.getDate();
  }

  function getHeightLevel(levelIndex) {
    if (result.height_level === levelIndex) {
      return result.height_color;
    }
    return "";
  }

  function getWeightHeightLevel(levelIndex) {
    if (result.weight_level === levelIndex) {
      return result.weight_color;
    }
    return "";
  }

  function getKidMonthDirect() {
    return kindDirectMonth + kindDirectYear * 12;
  }

  function validate() {
    const regWeight = /[0-9]+$/;
    const regHeight = /[0-9]+$/;

    if (inputType === 2 && kindDirectYear <= 0 && kindDirectMonth <= 0) {
      setErrorMessage("กรุณาระบุ อายุ ปีและเดือน เป็นตัวเลข จำนวนเต็ม");
      return false;
    }
    if (
      (inputType === 2 && regWeight.test(kindDirectYear) === false) ||
      kindDirectYear < 0
    ) {
      setErrorMessage("กรุณาระบุ อายุ ปี เป็นตัวเลข จำนวนเต็ม");
      return false;
    }
    if (
      (inputType === 2 && regWeight.test(kindDirectMonth) === false) ||
      kindDirectMonth < 0
    ) {
      setErrorMessage("กรุณาระบุ อายุ เดือน เป็นตัวเลข จำนวนเต็ม");
      return false;
    }

    if (
      kindHeight === 0 ||
      kindHeight < 0 ||
      regHeight.test(kindHeight) === false
    ) {
      setErrorMessage("กรุณาระบุ ส่วนสูง เป็นตัวเลข หรือ ทศนิยม");
      return false;
    }

    if (
      kindWeight === 0 ||
      kindWeight < 0 ||
      regWeight.test(kindWeight) === false
    ) {
      setErrorMessage("กรุณาระบุ น้ำหนัก เป็นตัวเลข หรือ ทศนิยม");
      return false;
    }
    setErrorMessage("");
    return true;
  }

  function reset() {
    setGender("M");

    setBirthDate(parseInt(getCurrentDay()));
    setBirthMonth(parseInt(getCurrentMonth()));
    setBirthYear(parseInt(getCurrentYear()));

    setBirthDateValue(parseInt(getCurrentDay()));
    setBirthMonthValue(parseInt(getCurrentMonth()));
    setBirthYearValue(parseInt(getCurrentYear()));

    setMeasureDate(parseInt(getCurrentDay()));
    setMeasureMonth(parseInt(getCurrentMonth()));
    setMeasureYear(parseInt(getCurrentYear()));

    setMeasureDateValue(parseInt(getCurrentDay()));
    setMeasureMonthValue(parseInt(getCurrentMonth()));
    setMeasureYearValue(parseInt(getCurrentYear()));

    setInputType(1);

    setKindMonth(0);
    setKindMonthText(0);

    setKindWeight("");
    setKindHeight("");

    setKindDirectMonth(0);
    setKindDirectYear(0);

    setErrorMessage("");

    setGraphImage("");
    setResult({
      kind_month: "-",
      kind_gender: "-",
      kind_birthday: "-",
      kind_height: "-",
      kind_weight: "-",
      measure_date: "-",
      ideal: "-",
      mean: "-",
      weight_level: 0,
      weight_color: "",
      height_level: 0,
      height_color: "",
      ha: "-",
      ha_persentage: "-",
    });
  }

  async function callApi() {
    // คำนวณอายุเป็นเดือนจากโหมดที่เลือก
    const m = inputType === 2 ? getKidMonthDirect() : getKidMonth();
    const mTxt = getKidYearMonth(m);
    // const { y: apiYears, m: apiMonths } = splitAgeYM(m); // ❌ ไม่ใช้แล้ว

    // อัปเดต state อายุเป็นข้อความ
    setKindMonth(m);
    setKindMonthText(mTxt);

    // เคลียร์ผลเก่า
    setGraphImage("");
    setBmiBucketIndex(null);
    setBmiRangeText("-");
    setBmiZScore("-");

    setResult({
      kind_month: "-",
      kind_gender: "-",
      kind_birthday: "-",
      kind_height: "-",
      kind_weight: "-",
      measure_date: "-",
      ideal: "-",
      mean: "-",
      weight_level: 0,
      weight_color: "",
      height_level: 0,
      height_color: "",
      ha: "-",
      ha_persentage: "-",
      bmi: "-",
      bmi_for_age_z: "-",
    });

    // ตรวจสอบอินพุต
    if (!validate()) {
      console.warn("ข้อมูลไม่ครบหรือไม่ถูกต้อง");
      return;
    }

    const requestOptions = { method: "GET" };
    const endPoint = `https://sync.kiddiary.in.th/ext2?cmd=all&height_age=${m}&gender=${gender}&height=${kindHeight}&weight=${kindWeight}&weight_age=${m}`;

    const heightM = Number(kindHeight) / 100;
    const bmiVal = Number(kindWeight) / (heightM * heightM);
    const bmiFixed = isFinite(bmiVal) ? bmiVal.toFixed(2) : "-";

    // 👇 ใช้ age = เดือนทั้งหมด + mapping gender -> male/female
    const bmiAge = m; // เดือนทั้งหมด
    const bmiGender = gender === "M" ? "male" : "female";

    const bmiUrl = `https://devapi.kiddiary.in.th/bmi?age=${bmiAge}&gender=${bmiGender}&bmi=${bmiFixed}`;

    setIsLoading(true); // เริ่มโชว์โหลด

    try {
      // ยิง 2 API พร้อมกัน
      const [bmiRes, mainRes] = await Promise.all([
        fetch(bmiUrl, requestOptions).then((r) => r.json()),
        fetch(endPoint, requestOptions).then((r) => r.json()),
      ]);

      // จัดการผล BMI
      const d = bmiRes?.data;
      if (d) {
        if (Number.isFinite(d.sd_index)) setBmiBucketIndex(d.sd_index);
        if (typeof d.sd_range === "string") setBmiRangeText(d.sd_range);
        // response ใหม่มีทั้ง z_score และ z_ind — ใช้ z_ind ตามเดิมได้
        if (Number.isFinite(d.z_ind)) setBmiZScore(d.z_ind.toFixed(2));
      }

      // จัดการผลหลัก + กราฟ
      resultApi(mainRes, mTxt, gender, m, kindWeight, kindHeight);
      setResult((prev) => ({ ...prev, bmi: bmiFixed }));
    } catch (e) {
      console.error("API error:", e);
    } finally {
      setIsLoading(false); // ปิดโหลด
    }
  }

  function callGraphApi(g, m, w, h) {
    setGraphImage("");
    const requestOptions = {
      method: "GET",
    };
    let endPoint = `https://chart.kiddiary.in.th/nutri/getGraph.php?gender=${g}&age=${m}&weight=${w}&height=${h}`;
    fetch(endPoint, requestOptions)
      .then((response) => response.json())
      .then(
        (data) => resultGraphApi(data),
        (error) => {
          if (error) {
          }
        }
      );
  }

  function resultGraphApi(data) {
    //console.log(data)

    refScroll.current.scrollIntoView({ behavior: "smooth" });
    setGraphImage(data.path);

    //track
    if (ga4react !== null) {
      try {
        ga4react.event("click_button_calculate");
        ga4react.event("calulate_" + gender);
      } catch (error) {
        console.log(error);
      }
    }
  }

  function resultApi(data, mTxt, g, m, w, h) {
    //console.log(data)
    //console.log(kindMonthText)

    let w4hLevel = 0;
    let w4hColor = 0;
    if (data.w4h.message !== null) {
      w4hLevel = data.w4h.message.level;
      w4hColor = data.w4h.message.color;
    }

    let heightLevel = 0;
    let heightColor = 0;
    if (data.height.message !== null) {
      heightLevel = data.height.message.level;
      heightColor = data.height.message.color;
    }

    let ibwValue = 0;
    let ibwMean = 0;
    if (data.ibw.message !== null) {
      ibwValue = `${data.ibw.message.median} กิโลกรัม`;
      ibwMean = `${data.ibw.message.percent} % ของ IBW`;
    }

    let dob = getKidBirthDay();
    let measureFullDate = getKidMeasure();
    if (inputType === 2) {
      dob = "-";
      measureFullDate = "-";
    }

    let haValue = 0;
    let haPersentage = 0;
    if (data.hPercent.message !== null) {
      haValue = data.hPercent.message.median;
      haPersentage = data.hPercent.message.percent;
      haValue = `${haValue} เซนติเมตร`;
      haPersentage = `${haPersentage} % median HA`;
    } else {
      haValue = "-";
      haPersentage = "-";
    }

    setResult({
      kind_month: mTxt,
      kind_gender: gender === "M" ? "ชาย" : "หญิง",
      kind_birthday: dob,
      kind_height: `${kindHeight} เซนติเมตร`,
      kind_weight: `${kindWeight} กิโลกรัม`,
      measure_date: measureFullDate,
      ideal: ibwValue,
      mean: ibwMean,
      weight_level: w4hLevel,
      weight_color: w4hColor,
      height_level: heightLevel,
      height_color: heightColor,
      ha: `${haValue}`,
      ha_persentage: `${haPersentage}`,
    });
    //console.log(result)
    callGraphApi(g, m, w, h);
  }

  function onChangeInputType(inp) {
    setInputType(inp);
  }

  function getKidMeasure() {
    return (
      measureDateValue +
      " " +
      getMonthTH(parseInt(measureMonthValue)) +
      " " +
      (parseInt(measureYearValue) + 543)
    );
  }
  function getKidBirthDay() {
    return (
      birthDateValue +
      " " +
      getMonthTH(parseInt(birthMonthValue)) +
      " " +
      (parseInt(birthYearValue) + 543)
    );
  }
  function getMonthTH(m) {
    for (let i = 0; i < itemsMonth.length; i++) {
      if (itemsMonth[i].id === m) {
        return itemsMonth[i].description;
      }
    }
    return m;
  }

  function getKidYearMonth(month) {
    let y = parseInt(parseInt(month) / 12);
    let m = parseInt(month) % 12;
    //console.log("getKidYearMonth: "+kindMonth)
    let r = "";
    if (y > 0) {
      r += `${y} ปี `;
    }
    if (m > 0) {
      r += `${m} เดือน`;
    }
    if (r === "") {
      return "0 เดือน";
    }
    //console.log(r)
    return r;
  }
  function getKidMonth() {
    let total = 0;

    let totalMonthMeasure =
      parseInt(measureYearValue) * 12 + parseInt(measureMonthValue);
    let totalMonthBirthday =
      parseInt(birthYearValue) * 12 + parseInt(birthMonthValue);

    // console.log("measureYear:"+measureYearValue)
    // console.log("measureMonth:"+measureMonthValue)

    // console.log("birthYear:"+birthYearValue)
    // console.log("birthMonth:"+birthMonthValue)

    // console.log("totalMonthMeasure:"+totalMonthMeasure)
    // console.log("totalMonthBirthday:"+totalMonthBirthday)

    // console.log("measureDateValue:"+measureDateValue)
    // console.log("birthDateValue:"+birthDateValue)

    total = totalMonthMeasure - totalMonthBirthday;

    if (birthDateValue > measureDateValue) {
      --total;
    }

    if (total < 0) {
      total = 0;
    }

    //console.log("getKidMonth:"+total)
    return total;
  }

  const location = useLocation();

  const [bmiZScore, setBmiZScore] = useState("-");

  // น้ำหนัก (กก.), ส่วนสูง (ซม.), เพศ, อายุเดือน
  // const weightKg = 50;
  // const heightCm = 160;
  // const sex = "boy"; // boy หรือ girl
  // const ageMonths = 168; // 14 ปี = 168 เดือน
  const weightKg = kindWeight;
  const heightCm = kindHeight;
  const sex = gender === "M" ? "boy" : "girl";
  const ageMonths = kindMonth;

  const LMS_DATA = {
    boy: {
      61: { L: -2, M: 14.5, S: 0.09 }, // 👈 เพิ่ม/ปรับให้ตรงมาตรฐานจริง
      168: { L: 0.9, M: 19.2, S: 0.08 },
      169: { L: 0.9, M: 19.3, S: 0.08 },
      192: { L: 1.1, M: 21.0, S: 0.09 },
    },
    girl: {
      61: { L: -2, M: 14.3, S: 0.09 }, // 👈 เพิ่ม/ปรับให้ตรงมาตรฐานจริง
      168: { L: 0.85, M: 19.0, S: 0.085 },
      169: { L: 0.85, M: 19.1, S: 0.085 },
      192: { L: 1.05, M: 20.0, S: 0.085 },
    },
  };

  function nearestAgeKey(obj, age) {
    const keys = Object.keys(obj).map(Number);
    if (keys.length === 0) return null;
    let best = keys[0];
    let bestDiff = Math.abs(keys[0] - age);
    for (const k of keys) {
      const diff = Math.abs(k - age);
      if (diff < bestDiff) {
        best = k;
        bestDiff = diff;
      }
    }
    return best;
  }

  // z-score formula (LMS): z = ( (BMI/M)^L - 1 ) / (L*S)
  function getBmiForAgeZScore(bmi, sex, ageMonths) {
    const table = LMS_DATA[sex];
    if (!table || !ageMonths) return null;

    const k = table[ageMonths]
      ? ageMonths
      : nearestAgeKey(table, Number(ageMonths));
    if (!k) return null;

    const { L, M, S } = table[k] || {};
    if (L == null || M == null || S == null || M <= 0 || S <= 0) return null;

    // ป้องกัน division error
    const ratio = bmi / M;
    if (!isFinite(ratio) || ratio <= 0) return null;

    const z = (Math.pow(ratio, L) - 1) / (L * S);
    return isFinite(z) ? z : null;
  }

  useEffect(() => {
    // ต้องมีน้ำหนัก/ส่วนสูง/อายุเดือน และอายุในช่วงที่คำนวณ BMI (61–228 เดือน)
    if (
      !kindWeight ||
      !kindHeight ||
      !kindMonth ||
      kindMonth < 61 ||
      kindMonth > 228
    ) {
      setBmiZScore("-");
      return;
    }

    const bmi = Number(kindWeight) / Math.pow(Number(kindHeight) / 100, 2);
    if (!isFinite(bmi)) {
      setBmiZScore("-");
      return;
    }

    const sexKey = gender === "M" ? "boy" : "girl";
    const z = getBmiForAgeZScore(bmi, sexKey, Number(kindMonth));
    setBmiZScore(z != null ? z.toFixed(2) : "-");
  }, [kindWeight, kindHeight, gender, kindMonth]);

  return (
    <div className="App">
      <div className="w-full flex flex-wrap">
        <div className="flex flex-wrap w-full  bg-blue-600 p-4">
          <div className="flex  my-auto mx-auto xl:mx-0 xl:my-0">
            <img className="w-24 h-24 xl:w-12 xl:h-12 " src={logo} alt="logo" />
          </div>
          <div className="flex flex-wrap text-center xl:text-left pl-0 xl:pl-5">
            <span className="text-start w-full text-white text-xl font-bold font-sarabun">
              Nutritional Status Calculator for Thai Children and Adolescents
              (NutStatCal-BMI)
            </span>
            <span className="text-start w-full text-white text-xs font-bold font-sarabun">
              {" "}
              Version bmi1.0 อัปเดทล่าสุด วันที่ 01/08/2568
            </span>
          </div>
        </div>

        {/* <div className="flex flex-wrap w-full p-4 mt-5 border-b justify-center gap-4">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `px-6 py-2 rounded-xl font-sarabun font-bold transition ${isActive || location.pathname === "/"
                ? "bg-red-600 text-white"
                : "bg-gray-100 text-gray-800 hover:bg-red-100"
              }`
            }
          >
            NutStatCal
          </NavLink>

          <NavLink
            to="/nutstatcal_bmi"
            className={({ isActive }) =>
              `px-6 py-2 rounded-xl font-sarabun font-bold transition ${isActive ? "bg-red-600 text-white" : "bg-gray-100 text-gray-800 hover:bg-red-100"
              }`
            }
          >
            NutStatCal-BMI
          </NavLink>
        </div> */}

        <div className="flex  flex-wrap w-full p-4 mt-5 border-b">
          <div className="flex  flex-wrap w-full xl:w-6/12 mx-auto justify-center">
            <div className="flex flex-wrap  w-full">
              <span className="mx-auto text-lg font-sarabun font-bold"></span>
            </div>

            <div className="flex flex-wrap w-full mt-0 xl:mt-4">
              <div className="flex flex-wrap w-full xl:w-2/6">
                <input
                  type="radio"
                  checked={inputType === 2}
                  name="in_type"
                  value="2"
                  className="my-auto mr-3"
                  onChange={() => onChangeInputType(2)}
                />
                <span className="text-md font-sarabun font-bold my-auto">
                  อายุ (ปี, เดือน)
                </span>
              </div>
              <div className="flex flex-wrap w-full xl:w-4/6">
                {inputType === 1 ? null : (
                  <div className="flex flex-wrap w-full   mt-2 xl:mt-0">
                    <input
                      className="border rounded-md p-1 w-16 content-end"
                      type="number"
                      onChange={(event) => {
                        setKindDirectYear(
                          parseInt(
                            event.target.value === "" ? 0 : event.target.value
                          )
                        );
                      }}
                      pattern="[0-9]*"
                    />
                    <span className="text-md font-sarabun my-auto ml-3 mr-3 xl:mr-6 ">
                      ปี
                    </span>
                    <input
                      className="border rounded-md p-1 w-16"
                      type="number"
                      onChange={(event) =>
                        setKindDirectMonth(
                          parseInt(
                            event.target.value === "" ? 0 : event.target.value
                          )
                        )
                      }
                      pattern="[0-9]*"
                    />
                    <span className="text-md font-sarabun my-auto  ml-3 mr-3 xl:mr-6">
                      เดือน
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="flex flex-wrap w-full mt-8 xl:mt-4">
              <div className="flex flex-wrap w-full xl:w-2/6">
                <input
                  type="radio"
                  checked={inputType === 1}
                  name="in_type"
                  value="1"
                  className="my-auto mr-3"
                  onChange={() => onChangeInputType(1)}
                />
                <span className="text-md font-sarabun font-bold my-auto">
                  วันเกิด{" "}
                </span>
              </div>
              <div className="flex flex-wrap w-full xl:w-4/6">
                {inputType === 2 ? null : (
                  <div className="flex flex-wrap w-full  mt-2 xl:mt-0">
                    <select
                      value={birthDate}
                      onChange={spinnerBirthDate}
                      className="w-18 text-md border rounded-md py-1 mr-2 pl-2 font-sarabun"
                    >
                      {itemsDate.map(function (item, index) {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.description}
                          </option>
                        );
                      })}
                    </select>
                    <select
                      value={birthMonth}
                      onChange={spinnerBirthMonth}
                      className="w-32 xl:w-36 text-md border rounded-md py-1 mr-2 pl-2 font-sarabun"
                    >
                      {itemsMonth.map(function (item, index) {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.description}
                          </option>
                        );
                      })}
                    </select>

                    <select
                      value={birthYear}
                      onChange={spinnerBirthYear}
                      className="w-20 xl:w-24 text-md border rounded-md py-1 mr-2 pl-2 font-sarabun"
                    >
                      {itemsYear.map(function (item, index) {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.description}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}
              </div>
            </div>

            {inputType === 2 ? null : (
              <div className="flex flex-wrap w-full">
                <div className="flex flex-wrap w-full mt-12">
                  <div className="flex flex-wrap w-full xl:w-2/6">
                    <span className="text-md font-sarabun font-bold my-auto">
                      วันที่ชั่งวัด
                    </span>
                  </div>
                  <div className="flex flex-wrap w-full xl:w-4/6  mt-2 xl:mt-0">
                    <select
                      value={measureDate}
                      onChange={spinnerMeasureDate}
                      className="w-18 text-md border rounded-md py-1 mr-2 pl-2 font-sarabun"
                    >
                      {itemsDate.map(function (item, index) {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.description}
                          </option>
                        );
                      })}
                    </select>
                    <select
                      value={measureMonth}
                      onChange={spinnerMeasureMonth}
                      className="w-32 xl:w-36 text-md border rounded-md py-1 mr-2 pl-2 font-sarabun"
                    >
                      {itemsMonth.map(function (item, index) {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.description}
                          </option>
                        );
                      })}
                    </select>
                    <select
                      value={measureYear}
                      onChange={spinnerMeasureYear}
                      className="w-20 xl:w-24 text-md border rounded-md py-1 mr-2 pl-2 font-sarabun"
                    >
                      {itemsYear.map(function (item, index) {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.description}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
            )}
            <div className="flex flex-wrap w-full mt-8 xl:mt-4">
              <div className="flex flex-wrap  w-2/6 xl:w-2/6">
                <span className="text-md font-sarabun font-bold">เพศ</span>
              </div>
              <div className="flex flex-wrap  w-4/6 xl:w-4/6 pr-0 xl:pr-12">
                <div
                  className={
                    "flex flex-wrap w-1/2 border rounded-tl-md  rounded-bl-md " +
                    (gender === "M"
                      ? " bg-green-900 hover:bg-green-200 "
                      : " bg-gray-200 ")
                  }
                >
                  <button
                    onClick={() => setGender("M")}
                    className="flex flex-wrap w-full"
                  >
                    <span className="m-auto font-sarabun">ชาย</span>
                  </button>
                </div>
                <div
                  className={
                    "flex flex-wrap w-1/2 border-r border-t border-b p-2 hover:bg-gray-200 rounded-tr-md  rounded-br-md  " +
                    (gender === "F"
                      ? " bg-pink-300 hover:bg-pink-200 "
                      : " bg-gray-200 ")
                  }
                >
                  <button
                    onClick={() => setGender("F")}
                    className="flex flex-wrap w-full"
                  >
                    <span className="m-auto font-sarabun">หญิง</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap w-full mt-4">
              <div className="flex flex-wrap  w-2/6 xl:w-2/6">
                <span className="text-md font-sarabun font-bold text-left ">
                  ส่วนสูง (เซนติเมตร)
                </span>
              </div>
              <div className="flex flex-wrap  w-4/6 xl:w-4/6">
                <input
                  value={kindHeight}
                  onChange={(event) =>
                    setKindHeight(
                      event.target.value === "0"
                        ? 0
                        : parseFloat(event.target.value)
                    )
                  }
                  className="border rounded-md p-1 w-full"
                  type="number"
                />
              </div>
            </div>

            <div className="flex flex-wrap w-full mt-4">
              <div className="flex flex-wrap  w-2/6 xl:w-2/6">
                <span className="text-md font-sarabun font-bold text-left ">
                  น้ำหนัก (กิโลกรัม)
                </span>
              </div>
              <div className="flex flex-wrap  w-4/6 xl:w-4/6">
                <input
                  value={kindWeight}
                  onChange={(event) =>
                    setKindWeight(
                      event.target.value === "0"
                        ? 0
                        : parseFloat(event.target.value)
                    )
                  }
                  className="border rounded-md p-1 w-full"
                  type="number"
                />
              </div>
            </div>

            <div className="flex flex-wrap w-full mt-5 justify-center">
              <span className="text-red-500">{errorMessage}</span>
            </div>

            <div className="flex flex-wrap w-full mt-5 justify-center mb-12">
              <button
                onClick={callApi}
                disabled={isLoading}
                className={`flex py-2 px-6 md:px-12 border rounded-xl font-sarabun
    ${
      isLoading
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-green-900 hover:bg-green-200"
    }
  `}
              >
                {isLoading ? "กำลังประเมิน..." : "ประเมิน"}
              </button>
              <button
                onClick={() => reset()}
                className="flex ml-5 md:ml-12 py-2 px-6 md:px-12 border bg-red-600 rounded-xl font-sarabun  hover:bg-red-200"
              >
                Reset
              </button>
            </div>
          </div>
        </div>

        <div className="flex  flex-wrap w-full p-4 mt-5 justify-center">
          <div className="flex  flex-wrap w-full xl:w-6/12">
            <span className="text-xs xl:text-sm font-sarabun text-justify">
              * NutStatCal-BMI สำหรับกุมารแพทย์และแพทย์ทั่วไป
              โปรแกรมประเมินภาวะโภชนาการของเด็ก เพื่อวินิจฉัยภาวะน้ำหนักเกิน
              (overweight) โรคอ้วน (obesity) ผอม (wasted/thin) ผอมแห้ง (severely
              wasted/severe acute malnutrition ในเด็กต่ำกว่า 5 ปี และ severely
              thin ในเด็กอายุ 5 ปีขึ้นไป) เตี้ย (stunted) เตี้ยแคระแกร็น
              (severely stunted) แสดง % of ideal body weight และ % of median
              height-for-age แสดงค่า BMI และ BMI-for-age z-score โดยอ้างอิง
              มาตรฐานการเจริญเติบโตขององค์การอนามัยโลก ปี ค.ศ. 2006
              (สำหรับเด็กอายุ 0-5 ปี) และ เกณฑ์อ้างอิงการเจริญเติบโตของเด็กอายุ
              5-19 ปี สำนักโภชนาการ กรมอนามัย พ.ศ. 2563 (สำหรับเด็กอายุ 5-19 ปี)
              และการวินิจฉัยภาวะน้ำหนักเกินและโรคอ้วนในเด็กและวัยรุ่น
              ตามแนวเวชปฏิบัติการป้องกันและดูแลรักษาโรคอ้วนในเด็กและวัยรุ่น พ.ศ.
              2568 จัดทำโดยสมาคมโภชนาการเด็กแห่งประเทศไทย
              ราชวิทยาลัยกุมารแพทย์แห่งประเทศไทย และสมาคมกุมารแพทย์แห่งประเทศไทย
            </span>
          </div>
        </div>

        <div className="flex  flex-wrap w-full p-4 mt-5">
          <div className="flex  flex-wrap w-full xl:w-8/12 mx-auto justify-center">
            <div ref={refScroll} className="flex flex-wrap  w-full">
              <span className="mx-auto text-lg font-sarabun font-bold">
                ผลการประเมินภาวะโภชนาการ
              </span>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold">อายุ</span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">
                  {result.kind_month}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold">เพศ</span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">
                  {result.kind_gender}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold">วันเกิด</span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">
                  {result.kind_birthday}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold">ส่วนสูง</span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">
                  {result.kind_height}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold">น้ำหนัก</span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">
                  {result.kind_weight}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold">
                  วันที่วัด
                </span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">
                  {result.measure_date}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6 content-start justify-start align-start">
                <span className="text-md font-sarabun  font-bold text-left">
                  Ideal Body Weight (IBW)
                </span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">{result.ideal}</span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold text-left">
                  น้ำหนักเป็น{" "}
                </span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">{result.mean}</span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold text-left">
                  Median Height-for-age (HA){" "}
                </span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">{result.ha}</span>
              </div>
            </div>

            <div className="flex flex-wrap  w-full mt-6">
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun font-bold text-left">
                  ส่วนสูงเป็น
                </span>
              </div>
              <div className="flex flex-wrap  w-3/6 xl:w-3/6">
                <span className="text-md font-sarabun">
                  {result.ha_persentage}
                </span>
              </div>
            </div>

            {/* เฉพาะช่วงอายุ 61 เดือน – 19 ปี */}
            {kindMonth >= 61 && kindMonth <= 228 && (
              <>
                <div className="flex flex-wrap w-full mt-6">
                  <div className="flex flex-wrap w-3/6 xl:w-3/6">
                    <span className="text-md font-sarabun font-bold text-left">
                      ดัชนีมวลกาย (Body Mass Index, BMI)
                    </span>
                  </div>
                  <div className="flex flex-wrap w-3/6 xl:w-3/6">
                    <span className="text-md font-sarabun">
                      {kindWeight && kindHeight
                        ? (
                            kindWeight /
                            ((kindHeight / 100) * (kindHeight / 100))
                          ).toFixed(2)
                        : "-"}
                    </span>
                    <span className="text-md font-sarabun ml-4">kg/m²</span>
                  </div>
                </div>

                <div className="flex flex-wrap w-full mt-6">
                  <div className="flex flex-wrap w-3/6 xl:w-3/6">
                    <span className="text-md font-sarabun font-bold text-left">
                      bmi-for-age-z-score
                    </span>
                  </div>
                  <div className="flex flex-wrap w-3/6 xl:w-3/6">
                    <span className="text-md font-sarabun">{bmiZScore}</span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="flex  flex-wrap w-full xl:w-8/12 mx-auto justify-center content-center pt-12 pb-12">
          <>
            <div className="flex flex-wrap  w-full mt-0">
              <span className="mx-auto text-lg font-sarabun font-bold align">
                ส่วนสูงตามเกณฑ์อายุ (Height-for-age)
              </span>
            </div>

            <div className="flex flex-wrap  w-full mt-4 ">
              <div className="flex flex-wrap  w-1/6 px-1 ">
                <div
                  className="h-4 bg-gray-100 w-full"
                  style={{ background: getHeightLevel(0) }}
                ></div>
                <span className="mx-auto text-xs xl:text-sm font-sarabun  mt-1">
                  เตี้ยแคระแกร็น <br />
                  (Servere stunted)
                </span>
              </div>
              <div className="flex flex-wrap  w-1/6 px-1 ">
                <div
                  className="h-4 bg-gray-100 w-full"
                  style={{ background: getHeightLevel(1) }}
                ></div>
                <span className="mx-auto text-xs xl:text-sm font-sarabun  mt-1">
                  เตี้ย <br />
                  (Stunted)
                </span>
              </div>
              <div className="flex flex-wrap  w-1/6 px-1">
                <div
                  className="h-4 bg-gray-100 w-full"
                  style={{ background: getHeightLevel(2) }}
                ></div>
                <span className="mx-auto text-xs xl:text-sm font-sarabun  mt-1">
                  ค่อนข้างเตี้ย
                </span>
              </div>
              <div className="flex flex-wrap  w-1/6 px-1">
                <div
                  className="h-4 bg-gray-100 w-full"
                  style={{ background: getHeightLevel(3) }}
                ></div>
                <span className="mx-auto text-xs xl:text-sm font-sarabun  mt-1">
                  ตามเกณฑ์
                </span>
              </div>
              <div className="flex flex-wrap  w-1/6 px-1">
                <div
                  className="h-4 bg-gray-100 w-full"
                  style={{ background: getHeightLevel(4) }}
                ></div>
                <span className="mx-auto text-xs xl:text-sm font-sarabun  mt-1">
                  ค่อนข้างสูง
                </span>
              </div>
              <div className="flex flex-wrap  w-1/6 px-1">
                <div
                  className="h-4 bg-gray-100 w-full"
                  style={{ background: getHeightLevel(5) }}
                ></div>
                <span className="mx-auto text-xs xl:text-sm font-sarabun  mt-1">
                  สูง
                </span>
              </div>
            </div>
          </>
          {/* แสดง Weight-for-height เฉพาะอายุ 0–60 เดือน */}
          {kindMonth <= 60 && (
            <>
              <div className="flex flex-wrap  w-full mt-10">
                <span className="mx-auto text-lg font-sarabun font-bold">
                  น้ำหนักตามเกณฑ์ส่วนสูง (Weight-for-height)
                </span>
              </div>

              <div className="flex w-full mt-4">
                <div className="flex flex-wrap w-2/12 xl:w-28 px-0.5">
                  <div
                    className="flex h-4 w-full"
                    style={{ background: getWeightHeightLevel(0) }}
                  />
                  <div className="flex w-full">
                    <p className="mx-auto text-xs font-sarabun mt-1">
                      ผอมแห้ง <br />
                      (Severe wasted
                      <br />
                      /severe acute
                      <br /> malnutrition)
                    </p>
                  </div>
                </div>

                <div className="flex flex-wrap w-2/12 xl:w-28 px-0.5">
                  <div
                    className="h-4 w-full"
                    style={{ background: getWeightHeightLevel(1) }}
                  />
                  <span className="mx-auto text-xs font-sarabun mt-1">
                    ผอม <br />
                    (Wasted)
                  </span>
                </div>

                <div className="flex flex-wrap w-2/12 xl:w-28 px-0.5">
                  <div
                    className="h-4 w-full"
                    style={{ background: getWeightHeightLevel(2) }}
                  />
                  <span className="mx-auto text-xs font-sarabun mt-1">
                    ค่อนข้างผอม
                  </span>
                </div>

                <div className="flex flex-wrap w-2/12 xl:w-28 px-0.5">
                  <div
                    className="h-4 w-full"
                    style={{ background: getWeightHeightLevel(3) }}
                  />
                  <span className="mx-auto text-xs font-sarabun mt-1">
                    สมส่วน
                  </span>
                </div>

                <div className="flex flex-wrap w-2/12 xl:w-28 px-0.5">
                  <div
                    className="h-4 w-full"
                    style={{ background: getWeightHeightLevel(4) }}
                  />
                  <span className="mx-auto text-xs font-sarabun mt-1">
                    ท้วม
                  </span>
                </div>

                <div className="flex flex-wrap w-2/12 xl:w-28 px-0.5">
                  <div
                    className="h-4 w-full"
                    style={{ background: getWeightHeightLevel(5) }}
                  />
                  <span className="mx-auto text-xs font-sarabun mt-1">
                    เริ่มอ้วน <br />
                    (Overweight)
                  </span>
                </div>

                <div className="flex flex-wrap w-2/12 xl:w-28 px-0.5">
                  <div
                    className="h-4 w-full"
                    style={{ background: getWeightHeightLevel(6) }}
                  />
                  <span className="mx-auto text-xs font-sarabun mt-1">
                    อ้วน <br />
                    (Obese)
                  </span>
                </div>
              </div>
            </>
          )}

          <>
            {/* 0–60 months */}
            {/* <div className="flex flex-wrap w-full mt-10">
              <span className="mx-auto text-lg font-sarabun font-bold">เกณฑ์ภาวะโภชนาการสำหรับเด็กอายุ 0–60 เดือน (Weight-for-height)</span>
            </div>

            <div className="flex w-full mt-4 flex-wrap justify-start gap-2">
              <div className="w-36 text-center">
                <div className="h-4 bg-gray-100 w-full" style={{ background: getWeightHeightLevel(0) }} />
                <p className="text-xs mt-1 font-sarabun">Severe wasted<br />(&lt; -3SD)</p>
              </div>
              <div className="w-36 text-center">
                <div className="h-4 bg-gray-100 w-full" style={{ background: getWeightHeightLevel(1) }} />
                <p className="text-xs mt-1 font-sarabun">Wasted<br />(-2SD to -3SD)</p>
              </div>
              <div className="w-36 text-center">
                <div className="h-4 bg-gray-100 w-full" style={{ background: getWeightHeightLevel(4) }} />
                <p className="text-xs mt-1 font-sarabun">Overweight<br />(+2SD to +3SD)</p>
              </div>
              <div className="w-36 text-center">
                <div className="h-4 bg-gray-100 w-full" style={{ background: getWeightHeightLevel(5) }} />
                <p className="text-xs mt-1 font-sarabun">Obese<br />({`>`} +3SD)</p>
              </div>
            </div> */}

            {/* 61 months – 19 years */}
            {Number(kindMonth) >= 61 && Number(kindMonth) <= 228 && (
              <>
                <div className="flex flex-wrap w-full mt-10">
                  <span className="mx-auto text-lg font-sarabun font-bold">
                    เกณฑ์ภาวะโภชนาการสำหรับเด็กอายุ 61 เดือน–19 ปี (BMI-for-age)
                  </span>
                </div>

                <div className="flex w-full mt-4 flex-nowrap overflow-x-auto gap-2">
                  <div className="flex flex-wrap w-2/12 xl:w-1/6 px-0.5">
                    <div
                      className="h-4 bg-gray-100 w-full"
                      style={{ background: getBmiLevel(0) }}
                    />
                    <p className="text-xs mt-1 font-sarabun">
                      Severely thin
                      <br />
                      (&lt; -3SD)
                    </p>
                  </div>
                  <div className="flex flex-wrap w-2/12 xl:w-1/6 px-0.5">
                    <div
                      className="h-4 bg-gray-100 w-full"
                      style={{ background: getBmiLevel(1) }}
                    />
                    <p className="text-xs mt-1 font-sarabun">
                      Thin
                      <br />
                      (-3SD to -2SD)
                    </p>
                  </div>
                  <div className="flex flex-wrap w-2/12 xl:w-1/6 px-0.5">
                    <div
                      className="h-4 bg-gray-100 w-full"
                      style={{ background: getBmiLevel(2) }}
                    />
                    <p className="text-xs mt-1 font-sarabun">
                      Normal
                      <br />
                      (-2SD to +1SD)
                    </p>
                  </div>
                  <div className="flex flex-wrap w-2/12 xl:w-1/6 px-0.5">
                    <div
                      className="h-4 bg-gray-100 w-full"
                      style={{ background: getBmiLevel(3) }}
                    />
                    <p className="text-xs mt-1 font-sarabun">
                      Overweight
                      <br />
                      (+1SD to +2SD)
                    </p>
                  </div>
                  <div className="flex flex-wrap w-2/12 xl:w-1/6 px-0.5">
                    <div
                      className="h-4 bg-gray-100 w-full"
                      style={{ background: getBmiLevel(4) }}
                    />
                    <p className="text-xs mt-1 font-sarabun">
                      Obese
                      <br />
                      (&gt; +2SD)
                    </p>
                  </div>
                  <div className="flex flex-wrap w-2/12 xl:w-1/6 px-0.5">
                    <div
                      className="h-4 bg-gray-100 w-full"
                      style={{ background: getBmiLevel(5) }}
                    />
                    <p className="text-xs mt-1 font-sarabun">
                      Severely obese
                      <br />
                      (&gt; +3SD)
                    </p>
                  </div>
                </div>
              </>
            )}
          </>

          {graphImage !== "" && Number(kindMonth) <= 60 ? (
            <div className="flex flex-wrap  w-full mt-4  ">
              <a href={graphImage} target="_blank">
                <img src={graphImage} alt="" />
              </a>
            </div>
          ) : null}
        </div>
      </div>

      <div className="flex flex-wrap  w-full mt-4  pb-3">
        <span className="flex flex-wrap  w-full text-sm xl:text-md  font-sarabun text-center justify-center">
          พัฒนาโดย
        </span>
        <span className="flex flex-wrap  w-full text-xs  xl:text-sm font-sarabun justify-center ">
          ศ.พญ.ลัดดา เหมาะสุวรรณ
        </span>
        <span className="flex flex-wrap  w-full text-xs  xl:text-sm font-sarabun justify-center">
          ดร.สุปิยา เจริญศิริวัฒน์
        </span>
        <span className="flex flex-wrap  w-full text-xs   xl:text-sm font-sarabun justify-center">
          นายพงษ์ศักดิ์ ติยานันทิ
        </span>
      </div>

      <footer className=" p-4   bg-red-600 text-white font-sarabun justify-center content-center">
        <img src={logoKidDiary} className="w-8 h-8 mx-auto" alt="" />

        <span className="text-sm">Powered by KidDiary</span>
      </footer>

      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="flex flex-col items-center">
            <div className="h-12 w-12 rounded-full border-4 border-white/40 border-t-white animate-spin" />
            <span className="mt-3 text-white font-sarabun">
              กำลังประเมิน...
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default NutStatCalBMI;
